import React, { FC } from 'react'
import cn from 'classnames'
import { Flag } from '@/components/Flag'

import styles from './SelectCountry.module.scss'

interface ISelectCountryProps {
  className?: string
}
export const SelectCountry: FC<ISelectCountryProps> = ({ className }) => {
  return (
    <div className={cn(className, styles.container)}>
      <div className={styles.flagWrap}>
        <Flag code="ru" className={styles.flag} />
      </div>
      Российская Федерация
    </div>
  )
}
